import * as React from 'react';
import App from './showcase';
import { Router, Route } from 'react-router-dom';
import { getStoreState } from './state/Store';

export default () => (
  <Router history={getStoreState().app.history}>
    <Route component={App} />
  </Router>
);



// WEBPACK FOOTER //
// ./src/App.tsx